import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

/*
 * Fixed bottom nav — About | Contact
 * Appears on all pages. On the landing page, links scroll to sections.
 * On sub-pages, links navigate via routes.
 */
export default function Navbar() {
  const { pathname, hash } = useLocation();
  const isLanding = pathname === '/';

  // Route transitions render the landing sections after the URL hash changes.
  useEffect(() => {
    if (!isLanding || !hash) return;
    document.getElementById(hash.slice(1))?.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  }, [isLanding, hash]);

  return (
    <nav
      aria-label="Main navigation"
      style={{
        position:       'fixed',
        bottom:         0,
        left:           0,
        right:          0,
        zIndex:         50,
        padding:        '1.2rem 2rem',
        display:        'flex',
        justifyContent: 'space-between',
        alignItems:     'center',
        fontFamily:     'var(--font-body)',
        fontSize:       '0.75rem',
        fontWeight:     300,
        color:          'var(--text-dim)',
        pointerEvents:  'auto',
      }}
    >
      <Link to="/" style={linkStyle}>© {new Date().getFullYear()} TRLR</Link>
      <div style={{ display: 'flex', gap: '1.5rem' }}>
        {isLanding ? (
          <>
            <a href="#about"   style={linkStyle}>About</a>
            <a href="#contact" style={linkStyle}>Contact</a>
          </>
        ) : (
          <>
            <Link to="/#about"   style={linkStyle}>About</Link>
            <Link to="/#contact" style={linkStyle}>Contact</Link>
          </>
        )}
      </div>
    </nav>
  );
}

const linkStyle = {
  color:          'var(--text-dim)',
  textDecoration: 'none',
  transition:     'color 0.3s',
};
